import { DIALOG_ACTION_TYPE } from 'store/global/actions';

const initialState = [];

// NOTE: Do not use immer here, breaks supporting of passing ref through payload
// because of auto freezing feature
const dialogsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DIALOG_ACTION_TYPE.OPEN_DIALOG: {
      return state.concat(payload);
    }

    case DIALOG_ACTION_TYPE.UPDATE_DIALOG_OPTIONS: {
      return state.map(dialog => (dialog.id === payload.id ? { ...dialog, ...payload } : dialog));
    }

    case DIALOG_ACTION_TYPE.CLOSE_DIALOG: {
      return payload?.id ? state.filter(({ id }) => id !== payload.id) : [];
    }

    default: {
      return state;
    }
  }
};

export default dialogsReducer;
